module.exports = __webpack_public_path__ + "static/media/info.44048fa3.png";